import apiClient from '../middleware/apiClient';
import { BILL_DATA } from '../helpers/apis';
import { COTTON_BILL_DATA } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_BILL_DATA = 'GET_BILL_DATA';
export const GET_BILL_DATA_SUCCESS = 'GET_BILL_DATA_SUCCESS';
export const GET_BILL_DATA_FAILURE = 'GET_BILL_DATA_FAILURE';

function dispatchGetBillData(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_BILL_DATA : BILL_DATA;
  return {
    type: GET_BILL_DATA,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetBillDataSuccess(billData) {
  return {
    type: GET_BILL_DATA_SUCCESS,
    payload: billData,
  };
}

function dispatchGetBillDataFailure(error) {
  return {
    type: GET_BILL_DATA_FAILURE,
    payload: error,
  };
}

export const getBillData = (options = {}) => async (dispatch, getState) => {
  const { billData: { cached } = {} } = getState();
  if (cached && !options.force) {
    return null;
  }

  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchGetBillData(isCottonSession)).payload;
    return dispatch(dispatchGetBillDataSuccess(response));
  } catch (error) {
    dispatch(dispatchGetBillDataFailure(error));
    throw error;
  }
};
